import React from "react";
import PolicyPage from "./PolicyPage";
import { policyDocuments } from "../Datas/policyData";

function PolicyDocument({ slug }) {
  return <PolicyPage document={policyDocuments[slug]} />;
}

export default PolicyDocument;
